import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { GET_MANAGER_ACCESS_LOGS } from "../../configs/apiConfig";

export interface IManagerAccessLogFilters {
  dateFrom?: string;
  dateTo?: string;
  requestedByUserId?: number;
  actionType?: string;
  storeId?: number;
}

export const getManagerAccessLogsAction = createAsyncThunk(
  "managerAccessLog/getLogs",
  async (filters: IManagerAccessLogFilters = {}, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const params: Record<string, string | number> = {};

      if (filters.dateFrom) params.dateFrom = filters.dateFrom;
      if (filters.dateTo) params.dateTo = filters.dateTo;
      if (filters.requestedByUserId) params.requestedByUserId = filters.requestedByUserId;
      if (filters.actionType) params.actionType = filters.actionType;
      if (filters.storeId) params.storeId = filters.storeId;

      const response = await axios.get(GET_MANAGER_ACCESS_LOGS, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });

      return response.data.body;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Failed to fetch manager access logs"
      );
    }
  }
);
